/**
 * Puente pack → motor: el motor solo entiende listas de etiquetas (`Theme`).
 */

import type { Theme } from '@murdoku/engine';
import { createRng } from '@murdoku/engine';
import type { ThemePack } from './schema';

/** Tema para el motor con los elementos del pack en su orden original. */
export function themeForEngine(pack: ThemePack): Theme {
  return {
    id: pack.id,
    people: pack.people.map((p) => p.name),
    rooms: pack.rooms.map((r) => r.name),
    hours: [...pack.hours],
  };
}

/**
 * Tema muestreado: baraja personas y salas de forma determinista por semilla, para
 * que un pack de 8 dé variedad a casos de N=4..6. Las horas no se barajan — son una
 * línea temporal — y se recortan desde el principio del rango.
 */
export function sampleTheme(pack: ThemePack, seed: string | number): Theme {
  const rng = createRng(`${pack.id}:${String(seed)}:sample`);
  return {
    id: pack.id,
    people: rng.shuffle(pack.people.map((p) => p.name)),
    rooms: rng.shuffle(pack.rooms.map((r) => r.name)),
    hours: [...pack.hours],
  };
}
